// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1UaGW","imageContainer":"_3kf6R","image":"_1_PO-","button":"_1EYLb","slider":"_1-1J2","slide":"_1BlO6"};